<template>
  <div>
    <b-card>
      <section name="header-table">
        <div class="organism-site_header card-padding">
          <span class="header__label">Location Management</span>
        </div>
        <div class="row card-padding pt-0">
          <div class="col-12 col-sm-7 col-md-4">
            <atom-input
              v-model="filter.siteName"
              title="Name"
              placeholder="Name"
            ></atom-input>
          </div>
          <div
            class="col-12 col-sm-5 col-md-8 mt-1 mt-sm-0 d-flex align-items-end justify-content-end justify-content-sm-start"
          >
            <div class="d-flex align-items-center">
              <atom-button
                buttonId="button-search"
                class="search__button"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="onClickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="row mt-1">
        <div class="col-12">
          <b-table
            responsive
            :items="items"
            :fields="fields"
            :hover="true"
            @row-clicked="selectRow"
          >
            <template #cell(deleteIcon)="data">
              <atom-button
                buttonId="button-delete"
                iconLeft="Trash2Icon"
                buttonStyle="flat"
                buttonColor="secondary"
                @click="openModal(data)"
              ></atom-button>
            </template>
            <template #cell(updated)="data">
              <div>{{ data.value.date }}</div>
              <div class="sub-header">{{ data.value.time }}</div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row card-padding">
        <div class="col-6">Showing {{ items.length }} entries</div>
      </div>
    </b-card>
    <footer style="height: 28px"></footer>
  </div>
</template>

<script>
import { BCard, BTable, BPagination } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixins from "@/mixins"
import AtomInput from "@/components/atoms/AtomInput.vue"

export default {
  name: "OrganismSiteManagement",
  components: {
    BCard,
    BTable,
    BPagination,
    AtomButton,
    MoleculeModalDialog,
    AtomInput,
  },
  mixins: [mixins],
  props: {
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    filter: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      pageSize: 10,
      siteSelectedId: "",
      siteSelectedName: "",
    }
  },
  methods: {
    selectRow(data) {
      this.$router.push(`/global-settings/data-management/location/${data.id}`)
    },

    handleChangeFilter() {
      this.$emit("onChangeFilter", this.filter)
    },

    handleChangePage(page) {
      this.filter.pageNumber = page
      this.handleChangeFilter()
    },

    clickButtonSearch() {
      this.handleChangeFilter()
    },

    onClickButtonClearFilter() {
      this.filter.siteName = undefined
      this.handleChangeFilter()
    },

    // modal
    openModal(data) {
      this.siteSelectedName = data.item.name
      this.siteSelectedId = data.item.id
      this.$bvModal.show(this.modalDeleteId)
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalDeleteId)
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-site_header {
  display: flex;
  flex-direction: column;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
}

.reset-filter-button {
  color: #b9b9c3;
  text-decoration: underline;

  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}

@media screen and (min-width: 576px) {
  .organism-site_header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
